module.exports = __webpack_public_path__ + "static/blog_image-bcc9c3f9adda885570d587366c29a29c.png";